import "jquery-ui"
import "jquery-ui/ui/i18n/datepicker-ja"

$(() => {
  $.get("https://holidays-jp.github.io/api/v1/date.json", function(holidaysData) {
    var day = ['日', '月', '火', '水', '木', '金', '土'];
    var holidays = Object.keys(holidaysData);

    $('.form-control-day').datepicker({
      dateFormat: "yy/m/d (DD)",
      dayNames: day,
      dayNamesMin: day,
      minDate: '+1d', //今日以降
      maxDate: '+1y', //1年後
      firstDay: 1,
      // beforeShowDay: function(date) {
      //   // 日曜日
      //   if (date.getDay() == 0) {
      //     return [false, 'sunday'];
      //   }
      //   // 土曜日
      //   if (date.getDay() == 6) {
      //     return [false, 'saturday'];
      //   }

      //   // 祝日
      //   for (var i = 0; i < holidays.length; i++) {
      //     var holiday = new Date(Date.parse(holidays[i]));
      //     if (
      //         holiday.getFullYear() == date.getFullYear() &&
      //         holiday.getMonth() == date.getMonth() &&
      //         holiday.getDate() == date.getDate()
      //       ) {
      //         return [false, 'day-holiday', null];
      //     }
      //   }

      //   // 平日
      //   return [true, ''];
      // },
    });
  });
})